import { render, staticRenderFns } from "./AiSuggestionTag.vue?vue&type=template&id=39f0b502&scoped=true"
import script from "./AiSuggestionTag.vue?vue&type=script&lang=js"
export * from "./AiSuggestionTag.vue?vue&type=script&lang=js"
import style0 from "./AiSuggestionTag.vue?vue&type=style&index=0&id=39f0b502&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f0b502",
  null
  
)

export default component.exports